import React, { useEffect, useState } from 'react'
import { fnObjNameStatus } from '../../../const/constStatuses_waterTruckRequest'
import { toastSweetAlert } from '../../Helpers/ToastSweetAlert'

const statusesWaterTruck = fnObjNameStatus()
const LayoutRoutePoints = ({
  routesPoints,
  currentRoutePoint,
  setCurrentRoutePoint,
}) => {
  const boxScroll = React.useRef(null)
  // useEffect(() => {
  //   if(!currentRoutePoint) return
  //   const routePointId

  // }, [currentRoutePoint])

  useEffect(() => {
    if (boxScroll && boxScroll.current) {
      scrollToCurrentRoutePoint()
    }
  }, [boxScroll])

  const scrollToCurrentRoutePoint = () => {
    if (boxScroll && boxScroll.current) {
      const element = boxScroll.current
      element.scrollTop = element.scrollHeight

      setTimeout(() => {
        const lists = element.querySelectorAll('li')
        lists.forEach((list) => {
          if (list.classList.contains('active')) {
            list.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        })
      }, 300)
    }
  }

  const handleCurrentRoutePoint = (destination, idx) => {
    const statusIdCompleted = statusesWaterTruck.completado
    const verifyStatus =
      currentRoutePoint.RoutePointsToWaterTruckRequest.StatusOfWaterTruckRequest
        .id === statusIdCompleted

    if (
      currentRoutePoint.loaded_at !== null &&
      currentRoutePoint.delivered_at !== null &&
      verifyStatus
    ) {
      return setCurrentRoutePoint(destination)
    }

    if (currentRoutePoint.loaded_at !== null) {
      if (currentRoutePoint.id === destination.id) return

      return toastSweetAlert(
        {
          mode: 'modalGeneric',
          icon: 'warning',
          message:
            'Por favor, complete el punto de entrega actual para continuar',
        },
        scrollToCurrentRoutePoint()
      )
    }
    if (currentRoutePoint.delivered_at !== null) return

    return setCurrentRoutePoint(destination)
  }

  return (
    <div
      className="timeLine-body"
      ref={boxScroll}
      style={{
        maxHeight: '200px',
        overflowY: 'auto',
        width: '100%',
      }}
    >
      <ul className="route-list ">
        {routesPoints.length > 0 &&
          routesPoints.map((destination, idx) => {
            const status = destination.RoutePointsToWaterTruckRequest.status_id
            const isActive = currentRoutePoint?.id === destination.id
            return (
              <>
                <li
                  id={`point-${destination.id}`}
                  key={idx}
                  className={`list-item ${isActive ? 'active' : ''}
                  ${
                    status === statusesWaterTruck.completado
                      ? 'text-success'
                      : ''
                  } 
                  `}
                  onClick={() => handleCurrentRoutePoint(destination, idx)}
                  style={{
                    cursor: 'pointer',
                  }}
                >
                  <div>
                    <p>
                      <i className="fas fa-map-pin"></i>
                      {destination.RoutePointsToWaterTruckRequest.folio}
                    </p>
                    {
                      destination.RoutePointsToWaterTruckRequest
                        .AddressOfWaterTruckRequest.address_full
                    }
                  </div>
                </li>
              </>
            )
          })}
      </ul>
    </div>
  )
}

export default LayoutRoutePoints
